import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VuejsDialog from "vuejs-dialog"
import VueLocalStorage from "vue-localstorage"
import VueProgressBar from 'vue-progressbar'
import VueResource from 'vue-resource'
import Vuetify from 'vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'

import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import 'vuetify/dist/vuetify.min.css'
 
Vue.config.productionTip = false
Vue.use(VuejsDialog)
Vue.use(VueLocalStorage, {
  name: 'ls',
})
Vue.use(VueResource)
Vue.use(VueProgressBar, {
  color: 'rgb(145, 240, 178)',
  failedColor: 'green',
  height: '3px'
})
Vue.use(Vuetify)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBzWAluvkSwqEjD2xZFu1igw9_zi7nZkD0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  installComponents: true
})

Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', 'Token ' + Vue.ls.get("token"))
  request.headers.set('Content-Type', 'application/json')
  next()
})
new Vue({
  router,
  store,
  render: h => h(App),
  http: {
    root: store.state.connection.url,
    headers: {
      'Content-Type': 'application/json'
    }
  }
}).$mount('#app')
